import { Component, Input, OnInit } from '@angular/core';
import { QuestionComments } from 'src/app/models/report/question-comments.model';

@Component({
  selector: 'app-freetext-panel',
  templateUrl: './freetext-panel.component.html',
  styleUrls: ['./freetext-panel.component.scss']
})
export class FreetextPanelComponent implements OnInit {

  @Input()
  public subTitle: string;

  @Input()
  public freeTexts: string[] = [];

  @Input()
  public showSubTitle = false;

  @Input()
  public noMargin = false;

  @Input()
  public questionMode = false;

  @Input()
  public questionComments: QuestionComments[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
